import React from 'react';
import { Typography } from '@mui/material';
import { useContentContext } from '@qbe/dfc-content';
import { useTrackSummary } from 'hooks/useAnalytics';
import { useContentComplaintPartners } from 'utils/content';

const ExpenseModalContent = () => {
  const { getJSXContent } = useContentComplaintPartners({
    context: useContentContext(),
  });
  useTrackSummary('expenseModal');

  return <Typography style={{ textAlign: 'left' }}>{getJSXContent('Expense.modal.content')}</Typography>;
};

export default ExpenseModalContent;
